export const ACTION_KEY = "action";
export const CART_ID_KEY = "cart_id";
export const JOURNEY_ID_KEY = "journey_id";
export const OPEN_DRAWER_KEY = "open_drawer";
export const RETURN_DATE_KEY = "return_date";
export const SEGMENT_ID_KEY = "segment_id";
export const SELECTED_LEG_CARD_ID_KEY = "leg_card_id";
export const SELECTED_SEATS_KEY = "selected_seats";
export const TRIP_ID_KEY = "trip_id";
export const VIEW_KEY = "view";
